/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementTwitterIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementTwitterIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M9.04649 7.08118L13.1415 2H12.1711L8.61542 6.41192L5.77551 2H2.5L6.79451 8.6716L2.5 14H3.47044L7.22533 9.34086L10.2245 14H13.5L9.04626 7.08118H9.04649ZM7.71735 8.73038L7.28222 8.06604L3.8201 2.77981H5.31064L8.10461 7.04596L8.53973 7.71031L12.1716 13.2557H10.681L7.71735 8.73063V8.73038Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementTwitterIcon.tags = ['twitter', 'x'];

ElementTwitterIcon.category = 'Navigator';

ElementTwitterIcon.iconSize = 16;
